<template>
      <div class="medicalAlertEdit">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'medicalAlert', params: {} }">
          Medical Alert
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'medicalAlertEdit', params:{id: id} }">
            Edit Medical Alert
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Edit Medical Alert</v-card-title>
          <v-card-text>
            <medicalAlert-form :id="id"></medicalAlert-form>
          </v-card-text>
        </v-card>
      </div>
    </template>

    <script>
    import MedicalAlertForm from './MedicalAlertForm.vue';

    export default {
      name: 'medicalAlert',
      data () {
        return {
          id: null
        }
      },
      components: {
        MedicalAlertForm
      },
      created () {
          this.id = this.$route.params.id;
          this.$emit("showParent", false);
      }
    }
    </script>
    